module.exports = __webpack_public_path__ + "img/cut_gd3.be053253.png";